import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Stack,
    Link,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
    expenseRatio: number;
    riskLevel: string;
    factsheetUrl: string;
    holdings: { name: string; weight: number }[];
}

const FundDetailsAccordion = ({
                                  expenseRatio,
                                  riskLevel,
                                  factsheetUrl,
                                  holdings,
                              }: Props) => {
    return (
        <Accordion sx={{ mt: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">Fund Details</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Stack spacing={1}>
                    <Typography variant="body2">
                        Risk Level: <strong>{riskLevel}</strong>
                    </Typography>

                    <Typography variant="body2">
                        Expense Ratio: <strong>{expenseRatio}%</strong>
                    </Typography>

                    <Link href={factsheetUrl} target="_blank" rel="noopener">
                        View Factsheet
                    </Link>

                    <Typography variant="subtitle2" mt={1}>
                        Top Holdings
                    </Typography>

                    {holdings.map((h) => (
                        <Typography key={h.name} variant="body2">
                            {h.name} — {h.weight}%
                        </Typography>
                    ))}

                    <Typography variant="caption" color="text.secondary" mt={1}>
                        Regulated by SEC Nigeria. NAV-based pricing.
                    </Typography>
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
};

export default FundDetailsAccordion;
